export default __webpack_public_path__ + "static/media/item3.dfaa7c81.png";